module.exports = __webpack_public_path__ + "static/img/4954_phase_function_Paper_PointsHejduk_Prediction.50d274d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4954_phase_function_Paper_PointsHejduk_Prediction.png
// module id = EUl8
// module chunks = 0